// extracted by mini-css-extract-plugin
export default {"container":"PokerTable_container__ln5BB","pokerTable":"PokerTable_pokerTable__AkZgg"};